
import React from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import { FaMicrophone, FaComments, FaHandshake, FaHeadset, FaHeartbeat } from 'react-icons/fa';
import { HiOutlineMicrophone } from "react-icons/hi";
import { HiDocumentText } from "react-icons/hi2";
import { PiCertificate, PiHandshake, PiHandshakeFill, PiHandshakeLight, PiHandshakeThin, PiMicrophone } from "react-icons/pi";
import { TfiCommentAlt } from "react-icons/tfi";
import { FaHeadSideCough, FaLaptopCode, FaScaleBalanced } from "react-icons/fa6";
import { BsCheck2Circle, BsHeadset } from "react-icons/bs";
import { HiMiniDocumentText } from "react-icons/hi2";

 
export function Accordion2() {
  const [open, setOpen] = React.useState(1);
 
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
 
  return (
    <>
      <div className="services-header mb-2">
        <h2>"Turning Words into Understanding Across Borders" </h2>
        <p>
        At LanguageHelpers, we believe that translation is more than just converting words—it’s 
        about preserving meaning, intent, and cultural nuance. Whether it’s legal documents, 
        business materials, or personal correspondence, our expert translators deliver precise 
        and culturally accurate translations that resonate with your audience. Trust us to help 
        you communicate effectively, no matter the language.
        </p>
      </div>
      <Accordion open={open === 1}>
        <AccordionHeader onClick={() => handleOpen(1)}>
            <p className="flex text-xl font-semibold">
                <FaHeartbeat size={40} className="m-2 text-red-600" />
                <span className="mt-3 mx-3">Medical Translation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">"Precision and confidentiality for healthcare." </span>
            Accurate translation of medical records, prescriptions, and healthcare documents to ensure 
            critical information is communicated effectively.
            {/* <p>&nbsp;</p> */}
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Translation of patient records, prescriptions, and discharge summaries.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Adaptation of clinical trial documents and medical research papers.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Ensures compliance with local healthcare regulations.
            </p>
        </AccordionBody>
      </Accordion>

      <Accordion open={open === 2}>
        <AccordionHeader className="" onClick={() => handleOpen(2)}>
            <p className="flex text-xl font-semibold">
                <FaScaleBalanced size={40} className="m-2.5" />
                <span className="mt-3 mx-3">Legal Translation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">“Every word matters in legal contexts.” </span>
            Translating contracts, court documents, and legal agreements with precision to meet 
            regulatory and cultural requirements.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Ideal for meetings, interviews, and smaller gatherings.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Certified for official use in legal proceedings.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Preserves the intent and terminology of complex legal language.
            </p>

        </AccordionBody>
      </Accordion>
      <Accordion open={open === 3}>
        <AccordionHeader onClick={() => handleOpen(3)}>
            <p className="flex text-xl font-semibold">
                <HiDocumentText size={42} className="m-2" />
                <span className="mt-3 mx-3">Document Translation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">"From official forms to personal letters." </span>
            High-quality translation of any type of document while preserving tone, meaning, and cultural nuance.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Translating business reports, resumes, and financial statements.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Adapting cultural tone in personal communications.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Quick turnaround for urgent document needs.
            </p>
        </AccordionBody>
      </Accordion>
      <Accordion open={open === 4}>
        <AccordionHeader onClick={() => handleOpen(4)}>
            <p className="flex text-xl font-semibold">
                <FaLaptopCode size={44} className="m-2" />
                <span className="mt-3 mx-3">Website and App Localization</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">"Speak your customers' language." </span>
            Adapting websites, mobile apps, and software to resonate with audiences in different regions, 
            enhancing user experience.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Translation of website content, UI/UX elements, and metadata.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Optimization for SEO in target languages.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Adaptation of graphics, currencies, and time formats.
            </p>
        </AccordionBody>
      </Accordion>
      <Accordion open={open === 5}>
        <AccordionHeader onClick={() => handleOpen(5)}>
            <p className="flex text-xl font-semibold">
                <PiCertificate size={44} className="m-2" />
                <span className="mt-3 mx-3">Certified Translation</span>
            </p>
        </AccordionHeader>
        <AccordionBody>
            <span className="italic">"Official and recognized." </span>
            Certified translations for legal, academic, and immigration documents, accepted worldwide by institutions and agencies.
            <p className="flex font-normal mt-3"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Certified translations for immigration, legal, and academic purposes.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Accepted by courts, universities, and government institutions.
            </p>
            <p className="flex font-normal"><span className="mx-3 my-0.5"><BsCheck2Circle size={17} /></span> 
                Delivered with an official certificate of accuracy.
            </p>
        </AccordionBody>
      </Accordion>
    </>
  );
}